const naturalCollator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

/**
 * Compares two strings using natural sort order (case-insensitive, numeric-aware).
 * @param {string|null|undefined} nameA
 * @param {string|null|undefined} nameB
 * @returns {number} negative if nameA < nameB, positive if nameA > nameB, 0 if equal
 */
export const naturalSort = (nameA, nameB) => naturalCollator.compare(nameA ?? '', nameB ?? '');

/**
 * Returns a naturally sorted copy of the collection by one or more keys.
 * If collection is not an array, returns it as-is.
 * @template T
 * @param {T[]|*} collection - Array to sort, or any non-array value
 * @param {string|string[]} keys - Key or keys to sort by
 * @returns {T[]|*}
 */
export const naturalSortBy = (collection, keys) => {
  if (!Array.isArray(collection)) {
    return collection;
  }

  const iteratee = [].concat(keys);

  return [...collection].sort((a, b) =>
    iteratee.reduce((result, key) => result || naturalSort(a[key], b[key]), 0),
  );
};
